// Apolo IDE — sessionMeta (sprint recents-claude-style).
//
// PURO: derivação de metadados de sessão pra sidebar/chat — data relativa curta,
// título heurístico da 1ª mensagem, e detecção de nome genérico (alvo do backfill).

// Segundos-unix (< 1e12) viram ms; ms passam direto.
const scaleEpoch = (n) => (n < 1e12 ? n * 1000 : n);

// Normaliza um timestamp (ms, segundos unix, ou ISO string) → ms epoch, ou null.
export function toMs(ts) {
  if (typeof ts === 'number') return Number.isFinite(ts) ? scaleEpoch(ts) : null;
  if (typeof ts !== 'string' || ts.trim() === '') return null;
  const n = Number(ts);
  if (Number.isFinite(n)) return scaleEpoch(n);
  const p = Date.parse(ts);
  return Number.isNaN(p) ? null : p;
}

const MONTHS_PT = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

// Data relativa CURTA pra a linha da sidebar: agora · 5min · 3h · ontem · 4d ·
// "18 ago" (mesmo ano) · "18 ago 24" (ano diferente). now injetável pra teste.
export function relativeDate(ts, now = Date.now()) {
  const ms = toMs(ts);
  if (ms == null) return '';
  const diff = now - ms;
  if (diff < 0) return 'agora';
  const min = Math.floor(diff / 60000);
  if (min < 1) return 'agora';
  if (min < 60) return `${min}min`;
  const hours = Math.floor(min / 60);
  if (hours < 24) return `${hours}h`;
  const days = Math.floor(hours / 24);
  if (days === 1) return 'ontem';
  if (days < 7) return `${days}d`;
  const d = new Date(ms);
  const sameYear = new Date(now).getFullYear() === d.getFullYear();
  const label = `${d.getDate()} ${MONTHS_PT[d.getMonth()]}`;
  return sameYear ? label : `${label} ${String(d.getFullYear()).slice(2)}`;
}

// Data completa pra divisor no chat / header: "segunda, 18 ago" (ou com ano).
const WEEKDAYS_PT = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];
export function fullDate(ts, now = Date.now()) {
  const ms = toMs(ts);
  if (ms == null) return '';
  const d = new Date(ms);
  const base = `${WEEKDAYS_PT[d.getDay()]}, ${d.getDate()} ${MONTHS_PT[d.getMonth()]}`;
  return new Date(now).getFullYear() === d.getFullYear() ? base : `${base} ${d.getFullYear()}`;
}

// Chave de dia (YYYY-MM-DD local) pra separar divisores por dia no chat.
export function dayKey(ts) {
  const ms = toMs(ts);
  if (ms == null) return '';
  const d = new Date(ms);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
